import React, { FunctionComponent, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { trackPage } from './tracking'
import { getOriginSystem, isAUDI, isVtiGiS } from '../../services/common/utils'
import ConfirmationPageVTIGIS from './ConfirmationPageVTIGIS'
import { getStorefrontData } from '../../services/redux/features/storefront.redux'
import ConfirmationPageAUDI from './ConfirmationPageAUDI'
import { CHI } from '../../components/CHI'
import { RootState } from '../../services/redux'

export type ConfirmationPageProps = {
  originSystem: string
}

const ConfirmationPage: FunctionComponent<ConfirmationPageProps> = () => {
  const { t } = useTranslation()
  const storefrontData = useSelector(getStorefrontData)
  const transactionId = useSelector((state: RootState) => state.storefront?.data?.transaction?.id);
  
  useEffect(() => {
    setTimeout(() => document.title = t(`confirmation:${getOriginSystem(storefrontData)}:tabTitle`, { defaultValue: t('confirmation:tabTitle')}))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t, storefrontData])

  useEffect(() => {
    trackPage()
  }, [])

  return (
    <>
      {isAUDI(storefrontData)  && (
        <ConfirmationPageAUDI />
      )}
      {isVtiGiS(storefrontData) && (
        <>
          <ConfirmationPageVTIGIS />
          <CHI storefrontId={transactionId} />
        </>
      )}
    </>
  )
}

export default ConfirmationPage
